import React, { useState } from "react";

import Sidebar from "../../components/admin/Sidebar";
import Navbar from "../../components/admin/Navbar";
import Footer from "../../components/Footer";
import LogoutModal from "../../components/admin/LogoutModal";
import Meta from "../../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";

const PainelScreen = () => {
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);


  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                  <h1 className="h3 mb-0 text-gray-800">
                    Painel Administrativo
                  </h1>
                </div>

             
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};

export default PainelScreen;
